/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unescaped-entities */

import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, TabItem, Button, FiltersSlide, Loader } from 'ypf-pas-general-ui-components';
import { MdFilterAlt } from 'react-icons/md';

import { useWorkReportModals } from '../../context/WorkReportModalsContext';
import { useFilterContext } from '../../context/FilterContext';
import useApproverWR from '../../hooks/useApproverWR';
import ApprovalPending from '../../components/ApprovalPending/ViewApprovalPendingContainer/ApprobalPending/ApprovalPending';
import ApprovalSend from '../../components/ApprovalSend/ApprovalSend';
import WorkReportModal from '../../components/WorkReportModals/WorkReportModals';
import './ApproverWorkReport.scss';
import NotFoundData from '../../components/NotFoundData/NotFoundData';
import useRequestDetailPermissions from '../../hooks/useRequestDetailPermissions';

const Filters = ({ mapFilters, onDelete }) => (
  <FiltersSlide arrayFilters={mapFilters} className="filters-chip " onDelete={onDelete} />
);

Filters.propTypes = {
  mapFilters: PropTypes.arrayOf({
    id: PropTypes.string,
    key: PropTypes.string,
    filter: PropTypes.string
  }),
  onDelete: PropTypes.func.isRequired
};

Filters.defaultProps = {
  mapFilters: []
};

const ApproverWorkReport = ({ setShowFilters, isFilterPinned }) => {
  const { filter, handleDeleteChips, handleChips } = useFilterContext();
  const [mapFilters, setMapFilters] = useState([]);
  const {
    data,
    loading,
    fetchData,
    setIsPending,
    setDateWorkReport,
    headBoard,
    isPending,
    pageIndex,
    size,
    setSize,
    setPageIndex,
    handleGoFirstLastDay,
    isOrderByUbication,
    handleOrderByUbication,
    handlePageSize
  } = useApproverWR();
  const { showModal, hideModal, props } = useWorkReportModals();

  const { permissions } = useRequestDetailPermissions({
    notifyTo: 3
  });

  const deleteFilter = (filterObj) => {
    const newMapFilters = mapFilters.filter(({ id }) => id !== filterObj?.id);

    setMapFilters(newMapFilters);
    handleDeleteChips(filterObj);
  };

  const fetchDataWithDefaultParams = ({ dailyWorkReportEdited = null } = {}) => {
    fetchData({
      pageNumber: pageIndex + 1,
      pageSize: size,
      dailyWorkReportEdited
    });
  };

  useEffect(() => {
    setMapFilters(handleChips({ isPending }));
  }, [filter, isPending]);

  return (
    <>
      <div className="container-approver-work-report">
        <div className="container-button-title">
          {isFilterPinned && (
            <Button
              className={mapFilters.length === 0 ? 'btn-filter-inactive' : 'btn-filter-active'}
              colorIcon="primary"
              icon={MdFilterAlt}
              onClick={() => setShowFilters(true)}
              sizeIcon="20px"
              type="button"
              variant="white"
              widthButton="40px"
            />
          )}
          <Button
            className={mapFilters.length === 0 ? 'btn-filter-inactive' : 'btn-filter-active'}
            colorIcon="primary"
            icon={MdFilterAlt}
            onClick={() => setShowFilters(true)}
            sizeIcon="20px"
            type="button"
            variant="white"
            widthButton="40px"
          />
          <h2 className="pas-title">Partes de trabajo</h2>
        </div>
      </div>
      <div className="position-relative">
        {loading && <Loader show text="CARGANDO ..." />}
        {data === null && <NotFoundData />}
        {data && (
          <>
            <Tabs className="tabs-container" defaultActiveKey="pendientes">
              <TabItem eventKey="pendientes" title="PENDIENTES">
                <>
                  {mapFilters.length ? (
                    <Filters mapFilters={mapFilters} onDelete={deleteFilter} />
                  ) : null}
                  <ApprovalPending
                    calendarioRevision={headBoard.fechasCalendario}
                    fetchData={fetchDataWithDefaultParams}
                    handleGoFirstLastDay={handleGoFirstLastDay}
                    handleOrderByUbication={handleOrderByUbication}
                    handlePageSize={handlePageSize}
                    isOrderByUbication={isOrderByUbication}
                    isPending={isPending}
                    pageIndex={pageIndex}
                    partesDiarios={headBoard.partesDiarios}
                    partesTotales={headBoard.partesTotales}
                    // permissions={permissions?.attachedFiles}
                    permissions={{
                      ...permissions?.attachedFiles,
                      ...permissions?.typeAndObjectImputation
                    }}
                    selectedDate={data.fecha}
                    setDateWorkReport={setDateWorkReport}
                    setIsPending={setIsPending}
                    setPageIndex={setPageIndex}
                    size={size}
                    totalPages={data.totalPages}
                    totalRecords={data.totalCount}
                    workReports={data.items}
                  />
                </>
              </TabItem>
              <TabItem eventKey="enviados" title="ENVIADOS">
                <>
                  {mapFilters.length ? (
                    <Filters mapFilters={mapFilters} onDelete={deleteFilter} />
                  ) : null}
                  <ApprovalSend
                    calendarioRevision={headBoard.fechasCalendario}
                    fetchData={fetchDataWithDefaultParams}
                    handleGoFirstLastDay={handleGoFirstLastDay}
                    handleOrderByUbication={handleOrderByUbication}
                    handlePageSize={handlePageSize}
                    isOrderByUbication={isOrderByUbication}
                    isPending={isPending}
                    pageIndex={pageIndex}
                    partesDiarios={headBoard.partesDiarios}
                    permissions={permissions?.attachedFiles}
                    selectedDate={data.fecha}
                    setDateWorkReport={setDateWorkReport}
                    setIsPending={setIsPending}
                    setPageIndex={setPageIndex}
                    setSize={setSize}
                    size={size}
                    totalPages={data.totalPages}
                    totalRecords={data.totalCount}
                    workReports={data.items}
                  />
                </>
              </TabItem>
            </Tabs>
            <WorkReportModal onHide={hideModal} showModal={showModal} {...props} />
          </>
        )}
      </div>
    </>
  );
};

ApproverWorkReport.propTypes = {
  setShowFilters: PropTypes.func.isRequired,
  isFilterPinned: PropTypes.bool
};

ApproverWorkReport.defaultProps = {
  isFilterPinned: false
};
export default ApproverWorkReport;
